import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import User from "~/models/User";
import ToastMessageStore from "~/stores/ToastMessageStore";
import LoggedInCustomerWrapper from "~/applications/panel/components/LoggedInCustomerWrapper";
import ClientPanelInvoiceIndexPage from "~/applications/panel/app/ClientPanelInvoiceIndexPage";
import BillingCentralMainPage from "~/modules/BillingCentral/app/BillingCentralMainPage";
import ClientPanelInvoiceViewPage from "~/applications/panel/app/ClientPanelInvoiceViewPage";
import ClientPanelSubscriptionEditPage from "~/applications/panel/app/ClientPanelSubscriptionEditPage";
import ClientPanelSubscriptionCreatePage from "~/applications/panel/app/ClientPanelSubscriptionCreatePage";
import ClientPanelSubscriptionIndexPage from "~/applications/panel/app/ClientPanelSubscriptionIndexPage";
import ClientPanelAddCreditCardPage from "~/applications/panel/app/ClientPanelAddCreditCardPage";

@observer
class BillingCentralRoutes extends Component {
  render() {
    const { user, toastMessageStore, ...rest } = this.props;

    return (
      <Switch>
        <Route
          exact
          path="/billing-central/invoices"
          render={routeProps => (
            <ClientPanelInvoiceIndexPage toastMessageStore={toastMessageStore} {...routeProps} {...rest} />
          )}
        />
        <Route
          path="/billing-central"
          render={routeProps => (
            <LoggedInCustomerWrapper user={user} {...rest} {...routeProps}>
              {({ customerStore }) => (
                <Switch>
                  <Route
                    exact
                    path="/billing-central/invoices/:invoiceId(\d+)"
                    render={innerRouteProps => (
                      <ClientPanelInvoiceViewPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/billing-central/subscriptions/:subscriptionId(\d+)"
                    render={innerRouteProps => (
                      <ClientPanelSubscriptionEditPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        stripeApiPublishableKey={window.panelProps.stripeApiPublishableKey}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/billing-central/subscriptions/create"
                    render={innerRouteProps => (
                      <ClientPanelSubscriptionCreatePage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        stripeApiPublishableKey={window.panelProps.stripeApiPublishableKey}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/billing-central/subscriptions"
                    render={innerRouteProps => (
                      <ClientPanelSubscriptionIndexPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/billing-central/credit-cards/add"
                    render={innerRouteProps => (
                      <ClientPanelAddCreditCardPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        stripeApiPublishableKey={window.panelProps.stripeApiPublishableKey}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/billing-central"
                    render={innerRouteProps => (
                      <BillingCentralMainPage
                        actualUserStore={customerStore}
                        toastMessageStore={toastMessageStore}
                        {...innerRouteProps}
                        {...rest}
                      />
                    )}
                  />
                </Switch>
              )}
            </LoggedInCustomerWrapper>
          )}
        />
      </Switch>
    );
  }
}

BillingCentralRoutes.propTypes = {
  user: PropTypes.instanceOf(User),
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default BillingCentralRoutes;
